<script setup lang="ts">
import { useBadgeStore } from '@shared/stores/badge';
import { computed } from 'vue';

// 1:1 port of customer-apps kgr-badge-counter: shows a reactive counter from the badge store,
// hidden (faded) while zero. The positioning class (e.g. kgr-verticalMenu__itemAddendum) is
// supplied by the caller.
const props = defineProps<{ badgeKey: string }>();

const badgeStore = useBadgeStore();
const count = computed(() => badgeStore.getCounter(props.badgeKey));
</script>

<template>
    <span
        class="kgr-badge kgr-badge--highlight kgr-hidden kgr-hidden--fadeInOnUnhidden"
        :class="{ 'is-unhidden': count > 0 }"
    >{{ count }}</span>
</template>

<style scoped>
span {
    display: block;
}
</style>
